import { useSelector } from 'react-redux';

import type { RootState } from '../../../../../../store';
import type { TreatmentPlanV3DischargePageState } from './types';

export default function useTreatmentPlanV3DischargePageState(): TreatmentPlanV3DischargePageState {
  const dischargePage = useSelector((state: RootState) => state.treatmentPlanV3.dischargePage);
  const dischargePageLoadCount = useSelector(
    (state: RootState) => state.treatmentPlanV3.dischargePageLoadCount,
  );
  const hasLoaded = dischargePage !== null;
  const hasLoadError = useSelector(
    (state: RootState) => state.treatmentPlanV3.dischargePageError != null,
  );
  const dischargePageLoading = useSelector(
    (state: RootState) => state.treatmentPlanV3.dischargePageLoading,
  );
  const isLoading = dischargePageLoading || (!hasLoaded && !hasLoadError);
  const isUpdatingCriteria = useSelector(
    (state: RootState) => state.treatmentPlanV3.updateDischargeCriteriaLoading,
  );
  const isSavingReason = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.createDischargeReasonLoading ||
      state.treatmentPlanV3.deleteDischargeReasonLoading,
  );

  return {
    dischargePage,
    dischargePageLoadCount,
    reasons: dischargePage?.reasons ?? [],
    isLoading,
    hasLoadError,
    isUpdatingCriteria,
    isSavingReason,
  };
}
